import React, { useState } from "react";
import {
  Modal,
  ModalClose,
  ModalDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  Select,
  Option,
  Textarea,
} from "@mui/joy";

const FeedbackModal = ({ open, onClose, fieldNames, onSubmit }) => {
  const [selectedField, setSelectedField] = useState("");
  const [comment, setComment] = useState("");

  const handleSubmit = () => {
    onSubmit({ field: selectedField, comment });
    setSelectedField("");
    setComment("");
    onClose();
  };

  const handleClose = () => {
    setSelectedField("");
    setComment("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog sx={{ minWidth: 400 }}>
        <ModalClose onClick={handleClose} />
        <DialogTitle>Report Issue</DialogTitle>
        <DialogContent>
          <FormControl sx={{ mt: 2 }}>
            <FormLabel>Field with issue</FormLabel>
            <Select
              placeholder="Select a field"
              value={selectedField}
              onChange={(_, value) => setSelectedField(value)}
            >
              {fieldNames.map((name) => (
                <Option key={name} value={name}>
                  {name}
                </Option>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ mt: 2 }}>
            <FormLabel>What is wrong?</FormLabel>
            <Textarea
              placeholder="Describe the issue..."
              minRows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} disabled={!selectedField}>
            Submit Feedback
          </Button>
          <Button variant="plain" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default FeedbackModal;



